import {
  put,
  call,
  takeEvery,
  all,
  select,
  takeLatest,
} from "redux-saga/effects";

import { getVacationInfo } from "../services/api";
import { vacationType } from "../reducers/actionTypes";
import { vacationDataSelector } from "@selectors/vacation.selector";
import vacationActions from "@actions/vacation.actions";

function* fetchVacationsData() {
  try {
    const { api = {} } = yield select(vacationDataSelector);
    const { fetched = false } = api || {};
    const { data } = yield call(getVacationInfo);
    yield put(vacationActions.getVacationDetails.success(data, null));
    if (!fetched)
      yield put(vacationActions.getVacationDetails.fetched({}, null));
  } catch (err) {
    yield put(vacationActions.getVacationDetails.error({ err }, null));
  }
}

export default function* () {
  yield all([
    takeLatest(vacationType.GET_VACATION_DATA_UPCOMING, fetchVacationsData),
  ]);
}
